module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade in",
    staticStyle: {
      "display": "block",
      "background": "rgba(230, 230, 230, 0.8)"
    },
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header modal-info"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.hideModal()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Alterar Valor da Recarga Automática")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "bold-600 text-center no-margin"
  }, [_vm._v("Valor da Recarga")]), _vm._v(" "), _c('div', {
    staticClass: "box-plus-minus"
  }, [_c('button', {
    staticClass: "inline bold btn-charge",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.calculate(_vm.rechargeAlter.valueTotal - _vm.multiple)
      }
    }
  }, [_c('i', {
    staticClass: "icon-minus"
  })]), _vm._v(" "), _c('input', {
    staticClass: "inline form-control bold",
    attrs: {
      "type": "text",
      "name": "",
      "readonly": ""
    },
    domProps: {
      "value": _vm._f("cents")(_vm.rechargeAlter.valueTotal)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "inline bold btn-charge",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.calculate(_vm.rechargeAlter.valueTotal + _vm.multiple)
      }
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "recharge-open-tax"
  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v(_vm._s(_vm._f("cents")(_vm.rechargeAlter.taxTotal)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModal()
      }
    }
  }, [_vm._v("\n          Cancelar\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.alterRechargeUnit()
      }
    }
  }, [_vm._v("\n          Confimar\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-9d098318!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/contract/modal-change-automatic-value.vue
// module id = 2196
// module chunks = 1